import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { renderNormalToCanvas, renderProToCanvas } from '../../models/MyDesignRenderer';

interface MyDesignCanvasProps {
  designType: 'normal' | 'pro';
  paletteColors: Uint8Array;
  colorData: Uint8Array | Uint8Array[];
  usage?: number;
  canvasSize?: number;
}

export const MyDesignCanvas: React.FC<MyDesignCanvasProps> = ({
  designType,
  paletteColors,
  colorData,
  usage = 9, // デフォルトは通常マイデザイン
  canvasSize = 192
}) => {
  const { t } = useTranslation('my_design');
  const canvasRef = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    if (canvasRef.current) {
      const ctx = canvasRef.current.getContext('2d');
      if (!ctx) {
        return;
      }
      if (Array.isArray(colorData) && colorData.length === 4) {
        renderProToCanvas(ctx, paletteColors, colorData, usage, canvasSize);
      } else {
        renderNormalToCanvas(ctx, paletteColors, colorData as Uint8Array, canvasSize);
      }
    }
  }, [designType, paletteColors, colorData, usage, canvasSize]);

  return (
    <canvas
      ref={canvasRef}
      width={canvasSize}
      height={canvasSize}
      aria-label={designType === 'pro' ? t('aria_image_pro') : t('aria_image')}
    />
  );
};
